import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { RecurringSchedulesComponent } from '../operations/recurring-schedules/recurring-schedules.component';

@Component({
  selector: 'phms-workflow-entry-points',
  standalone: true,
  imports: [CommonModule, RecurringSchedulesComponent],
  template: `<details (toggle)="opened($event)" class="entry-points">
    <summary>
      Advanced automation settings
      <small>Recurring schedules and delivery history</small>
    </summary>
    <ng-container *ngFor="let code of [workflowCode]">
      <p *ngIf="loaded && subjectTypeCode === 'hearing_cycle'">
        These settings control recurring starts and delivery. Use Start test
        above to test this published version with fresh hearing cases.
      </p>
      <phms-recurring-schedules
        *ngIf="loaded"
        [workflowCode]="code"
        [interactionBlocked]="interactionBlocked"
        (deliveryRequested)="openDelivery($event)"
      />
    </ng-container>
  </details>`,
  styles: [
    `
      .entry-points {
        border: 1px solid var(--custom-border-color);
        border-radius: 0.35rem;
        margin-block: 0.5rem;
        padding: 0.5rem;
      }
      summary {
        cursor: pointer;
        font-weight: 600;
      }
      small {
        font-weight: 400;
        margin-inline-start: 0.75rem;
      }
      phms-recurring-schedules {
        display: block;
        margin-top: 0.75rem;
      }
    `,
  ],
})
export class WorkflowEntryPointsComponent {
  private readonly router = inject(Router);
  @Input({ required: true }) workflowCode = '';
  @Input() subjectTypeCode: string | null = null;
  @Input() interactionBlocked = false;
  loaded = false;
  openDelivery(reference: { eventId: string; consumerId: string }): void {
    if (this.interactionBlocked) return;
    void this.router.navigate(['/platform-admin/operations'], {
      queryParams: reference,
    });
  }
  opened(event: Event) {
    if ((event.target as HTMLDetailsElement).open) this.loaded = true;
  }
}
